import { SET_ALERT } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.alert, action) {
  switch (action.type) {
    case SET_ALERT:
      return action.payload;
    case RESET_APP_STATE:
      return initialState.alert;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/alert/reducer.js